<template>
    <div class="b2corder">
        <Breadcrumb class="tablelist-header" v-if="!activeids">
            <BreadcrumbItem
                >{{ title[type]
                }}{{
                    $t("erp.b2c.b2c_order", { defaultValue: "B2C订单" })
                }}</BreadcrumbItem
            >
        </Breadcrumb>
        <Steps
            :current="statusIndex"
            class="bg-fff padding-20"
            v-if="type === 'query'"
        >
            <Step
                v-for="(val, key) of progressStatus"
                :title="val.name"
                :key="key"
            ></Step>
        </Steps>
        <div class="bg-fff padding-bottom-10" v-if="type == 'query'">
            <Form inline class="search-other"> </Form>
        </div>
        <div
            v-if="
                dataBaseInfo.errorCode != 'unexception' &&
                type == 'query' &&
                loading == false
            "
            class="errorCodebox"
        >
            {{ $t("erp.b2c.abnormal_order", { defaultValue: "异常订单" }) }}:{{
                filterCode(dataBaseInfo.errorCode)
            }}
        </div>
        <!-- 查看 -->
        <compBase :combaseInfo="dataBaseInfo" ref="refbase"></compBase>
        <!-- 关联 -->
        <compRelation
            v-if="type == 'query' && dataRelation != ''"
            :comreleVance="dataRelation"
            :nodeId="nodeid"
        ></compRelation>
        <!-- 收货 -->
        <compReceive
            v-if="b2cOrderInfo"
            :alltype="type"
            :comReceive="dataReceive"
            ref="refrevice"
        ></compReceive>
        <!-- 产品 -->
        <compProducts
            :alltype="type"
            :comProduct="dataProducts"
            ref="refproduct"
            :fulfillmentChannel="dataBaseInfo.fulfillmentChannel"
        ></compProducts>
        <!-- 仓库 -->
        <compLogistics
            :alltype="type"
            :comLogistics="dataLogistics"
            ref="refwarehouse"
        ></compLogistics>
        <!-- 包裹 -->
        <compPackages
            v-if="type == 'query' && dataPackages != ''"
            :comPackages="dataPackages"
        ></compPackages>
        <!-- 附件 -->
        <compEnclosure
            v-if="type == 'query' && dataEnclosure != ''"
            :comEnclosure="dataEnclosure"
        ></compEnclosure>
        <!-- 订单日志 -->
        <compOrderlog
            v-if="type == 'query'"
            :comOrderlog="dataOrderlog"
        ></compOrderlog>

        <footer class="bg-fff padding-20 text-right" v-if="type !== 'query'">
            <Button
                type="primary"
                class="width-10per margin-right-10"
                @click="submit(true)"
                >{{
                    $t("global.common.update_submit", { defaultValue: "提交" })
                }}</Button
            >
            <Button class="width-10per" @click="cancel">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </footer>

        <!-- 重置订单，项目手动，恢复弹框 -->
        <Modal v-model="operate.show" width="360" @on-cancel="close('all')">
            <div class="headercss">
                <p>{{ operate.title }}</p>
            </div>
            <div style="text-align: center; margin-top: 15px">
                <p>{{ operate.content }}</p>
            </div>
            <div slot="footer">
                <Button
                    type="error"
                    size="large"
                    :loading="showDel"
                    long
                    @click="oksubmit"
                    >{{
                        $t("global.common.update_OK", { defaultValue: "确定" })
                    }}</Button
                >
            </div>
        </Modal>
        <!-- 添加备注、手动回传、附件上传 -->
        <Modal
            class="hidefooter"
            v-model="handle.show"
            :mask-closable="false"
            v-bind="handle"
        >
            <component
                :is="handle.component"
                @on-close="handle = {}"
                @on-update="getDetail"
                v-bind="handle"
            ></component>
            <footer slot="footer" v-show="handle.footer"></footer>
        </Modal>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState } from "vuex";
// 各个子组件
import compBase from "../update/base";
import compRelation from "../update/relation";
import compReceive from "../update/receiving";
import compProducts from "../update/products";
import compLogistics from "../update/logistics";
import compPackages from "../update/packages";
import compEnclosure from "../update/enclosure";
import compOrderlog from "../update/orderlog";

import comAddnotes from "../alert/addnotes";
import comManualback from "../alert/manualback";
import comForcemanualback from "../alert/forcemanualback";
import comAttacheupload from "../alert/attachementupload";
// 请求的http
import {
    HttpqueryB2COrder,
    HttpSaveOne,
    HttpResetOrder,
    HttpRecoveryNormal,
    HttpAddRemark,
    HttpResubmit,
} from "@/service/boss/b2corder";
import { constants } from "os";
export default {
    name: "comIndex",
    props: ["activeids", "querytype"],
    components: {
        compBase,
        compRelation,
        compReceive,
        compProducts,
        compLogistics,
        compPackages,
        compEnclosure,
        compOrderlog,

        comAddnotes,
        comManualback,
        comForcemanualback,
        comAttacheupload,
    },
    data() {
        return {
            SYSID: "",
            showSubmit: false,
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            showDel: false,
            //issuper: this.$route.query.issuper == 1,
            nodeid: 0,
            status: "",
            baseData: {},
            title: {
                add: this.$t("global.common.operation_add", {
                    defaultValue: "新增",
                }),
                edit: this.$t("global.common.operation_edit", {
                    defaultValue: "编辑",
                }),
                query: this.$t("global.common.operation_see", {
                    defaultValue: "查看",
                }),
            },
            progressStatus: [
                {
                    value: "pending",
                    name: this.$t("erp.b2c.orderstatus_pending", {
                        defaultValue: "未支付",
                    }),
                },
                {
                    value: "unshipped",
                    name: this.$t("erp.b2c.orderstatus_unshipped", {
                        defaultValue: "未发货",
                    }),
                },
                {
                    value: "approved",
                    name: this.$t("erp.b2c.orderstatus_approved", {
                        defaultValue: "已审核",
                    }),
                },
                {
                    value: "assigned",
                    name: this.$t("erp.b2c.orderstatus_assigned", {
                        defaultValue: "已分配",
                    }),
                },
                {
                    value: "picked",
                    name: this.$t("erp.b2c.orderstatus_picked", {
                        defaultValue: "已配货",
                    }),
                },
                {
                    value: "shipped",
                    name: this.$t("erp.b2c.orderstatus_shipped", {
                        defaultValue: "已发货",
                    }),
                },
                {
                    value: "canceled",
                    name: this.$t("erp.b2c.orderstatus_canceled", {
                        defaultValue: "已取消",
                    }),
                },
            ],
            // 几个模块
            alldatas: "",
            dataBaseInfo: {},
            dataRelation: [],
            dataReceive: {},
            dataProducts: [],
            dataLogistics: {},
            dataPackages: [],
            dataEnclosure: [],
            dataOrderlog: [],

            operate: {
                // loading:true,
                show: false,
                title: "",
                content: "",
                oktext: this.$t("global.common.update_OK", {
                    defaultValue: "确定",
                }),
                canceltext: this.$t("global.common.operation_cancel", {
                    defaultValue: "取消",
                }),
            },

            statusIndex: 0,
            // 设置几个弹框的变量
            handle: {
                show: false,
                title: "",
                component: null,
            },
        };
    },
    created() {
        this.getDetail();
        this.b2cOrderInfo = this.handleAuth("erp.b2cOrder.address");
    },
    watch: {
        $route: function (to, from) {
            // console.log(to,from)
            // console.log(this.type)
            if (this.type == "query") {
                this.getDetail();
            }
        },
    },
    methods: {
        openloading() {
            // console.log(123123123)
            this.loading = true;
        },
        closeloading() {
            this.loading = false;
        },
        getDetail() {
            if (this.activeids) {
                this.id = this.activeids;
                this.type = this.querytype;
            } else {
                this.id = this.id;
                this.type = this.type;
            }
            this.loading = true;
            return HttpqueryB2COrder({
                orderId: this.id,
            }).then(
                (res) => {
                    this.handleResponse(res.data);
                    this.nodeid = res.data.nodeId;
                    this.alldatas = res.data;
                    sessionStorage.set("alldatas", JSON.stringify(res.data));
                    this.SYSID = global.SYSID;
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$Message.error({
                        content: err.message,
                        duration: 10,
                        closable: true,
                    });
                }
            );
        },
        handleOperate(val) {
            this.operate = {};
            switch (val) {
                case "reset":
                    this.operate.title = this.$t("erp.b2c.reset_order", {
                        defaultValue: "重置订单",
                    });
                    this.operate = {
                        show: true,
                        title: this.$t("erp.b2c.reset_order", {
                            defaultValue: "重置订单",
                        }),
                        content: this.$t("erp.b2c.resetorder_desc", {
                            defaultValue:
                                "订单重置后会恢复初始状态，并变为手工订单，是否确认提交？",
                        }),
                        type: val,
                    };
                    break;
                case "project":
                    this.operate = {
                        show: true,
                        title: this.$t("erp.b2c.project_manual", {
                            defaultValue: "项目手动关联",
                        }),
                        content: this.$t("erp.b2c.projectmanual_desc", {
                            defaultValue:
                                "确定手动关联项目？请先确认渠道产品已经添加",
                        }),
                        type: val,
                    };
                    break;
                case "addproduct":
                    const url = this.$router.resolve({
                        path: "/home/b2corder/addgistlist/edit",
                        query: { id: this.id },
                    });
                    window.open(url.href, "_blank");
                    break;
                case "addnotes":
                    this.handle = {
                        title: this.$t("erp.b2c.add_notes", {
                            defaultValue: "添加备注",
                        }),
                        show: true,
                        activeids: this.id,
                        width: 600,
                        component: "comAddnotes",
                    };
                    break;

                case "manualback":
                    this.handle = {
                        title: this.$t("erp.b2c.manual_back", {
                            defaultValue: "手动回传",
                        }),
                        show: true,
                        activeids: this.id,
                        nodeid: this.nodeid,
                        width: 1100,
                        component: "comManualback",
                    };
                    break;
                case "forcemanualback":
                    this.handle = {
                        title: this.$t("erp.b2c.mandatorymanual_back", {
                            defaultValue: "强制手动回传",
                        }),
                        show: true,
                        activeids: this.id,
                        nodeid: this.nodeid,
                        warehouseid: this.dataLogistics.orgWarehouseId,
                        width: 1100,
                        component: "comForcemanualback",
                    };
                    break;

                case "attacheupload":
                    this.handle = {
                        title: this.$t("erp.b2c.arrachement_upload", {
                            defaultValue: "附件上传",
                        }),
                        show: true,
                        activeids: this.id,
                        width: 1000,
                        component: "comAttacheupload",
                    };
                    break;
                case "normal":
                    this.operate.title = this.$t("erp.b2c.back_normal", {
                        defaultValue: "恢复正常",
                    });
                    this.operate = {
                        show: true,
                        title: this.$t("erp.b2c.back_normal", {
                            defaultValue: "恢复正常",
                        }),
                        content: this.$t("erp.b2c.backnormal_desc", {
                            defaultValue: "确定要将订单恢复为正常处理的订单？",
                        }),
                        type: val,
                    };
                    break;
                case "removeexcept":
                    this.operate.title = this.$t(
                        "erp.b2c.back_normal_onlyremove",
                        { defaultValue: "恢复正常 (仅去除异常)" }
                    );
                    this.operate = {
                        show: true,
                        title: this.$t("erp.b2c.back_normal_onlyremove", {
                            defaultValue: "恢复正常 (仅去除异常)",
                        }),
                        content: this.$t("erp.b2c.backnormal_onlyremovedesc", {
                            defaultValue:
                                "该操作仅去除订单的异常类型，不会进入订单自动处理流程",
                        }),
                        type: val,
                    };
                    break;
                case "resubmit":
                    this.operate = {
                        show: true,
                        title: this.$t("global.common.resubmit", {
                            defaultValue: "重新提交",
                        }),
                        content: this.$t("global.common.resubmit_desc", {
                            defaultValue:
                                "重新提交后，系统会重新自动处理当前订单",
                        }),
                        type: val,
                    };
                    break;
                case "edit":
                    this.handle = {
                        title: this.$t("global.common.operation_edit", {
                            defaultValue: "编辑",
                        }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeids: this.id,
                        querytype: "edit",
                    };
                    break;
            }
        },
        oksubmit() {
            let request,
                params = {},
                { type } = this.operate;
            let orderIds = [];
            orderIds.push(this.id);
            switch (type) {
                case "reset":
                    request = HttpResetOrder;
                    params = { orderIds };
                    break;
                case "project":
                    // request = HttpRecoveryNormal;
                    // params = { id }
                    break;
                case "normal":
                    request = HttpRecoveryNormal;
                    params = { orderIds: orderIds, recoveryNormal: 1 };
                    break;
                case "removeexcept":
                    request = HttpRecoveryNormal;
                    params = { orderIds: orderIds, recoveryNormal: 0 };
                    break;
                case "resubmit":
                    request = HttpResubmit;
                    params = { orderIds };
                    break;
            }
            this.showDel = true;
            request(params)
                .then((res) => {
                    this.operate.show = false;
                    this.$Message.success({
                        content: res.message,
                        duration: 10,
                        closable: true,
                    });
                    // this.$router.push({
                    //     name: "b2cOrder"
                    // })
                    // 重新进行请求
                    this.getDetail();
                    this.showDel = false;
                })
                .catch((err) => {
                    this.$Message.error({
                        content: err.message,
                        duration: 10,
                        closable: true,
                    });
                    this.showDel = false;
                });
        },
        close(val) {
            // console.log(val)
            switch (val) {
                case "all":
                    this.operate.show = false;
                    break;
            }

            // this.$emit('on-close')
        },
        handleResponse(data) {
            // 模块的赋值
            this.$set(this.$data, "dataBaseInfo", data.baseInfo || {});
            this.$set(this.$data, "dataRelation", data.relation || []);
            this.$set(this.$data, "dataReceive", data.receive || {});
            this.$set(this.$data, "dataProducts", data.products || []);
            this.$set(this.$data, "dataLogistics", data.logistics || {});
            this.$set(this.$data, "dataPackages", data.packages || []);
            this.$set(this.$data, "dataEnclosure", data.enclosure || []);
            this.$set(this.$data, "dataOrderlog", data.orderLog || []);

            const orderStatus = data.relation.orderStatus;
            let status = data.baseInfo.orderStatus;
            this.statusIndex = this.progressStatus.findIndex((item) => {
                return item.value === status;
            });
            if (orderStatus === "refunded") {
                this.progressStatus = [
                    {
                        value: "refunded",
                        name: this.$t("erp.b2c.orderstatus_refunded", {
                            defaultValue: "已退款",
                        }),
                    },
                ];
            } else if (orderStatus === "canceled") {
                this.progressStatus = [
                    {
                        value: "canceled",
                        name: this.$t("erp.b2c.orderstatus_canceled", {
                            defaultValue: "已取消",
                        }),
                    },
                ];
            }
        },
        submit() {
            let refbase = this.$refs.refbase;
            let refrevice = this.$refs.refrevice;
            let refproduct = this.$refs.refproduct;
            let refwarehouse = this.$refs.refwarehouse;
            let flag = false;
            // console.log(refrevice.formData)
            for (var key in refrevice.formData) {
                if (
                    refrevice.formData["addressline"] == "" ||
                    refrevice.formData["city"] == "" ||
                    refrevice.formData["countryCode"] == "" ||
                    refrevice.formData["postalCode"] == "" ||
                    !refrevice.formData["shippingName"]
                ) {
                    flag = true;
                }
            }
            for (var key in refwarehouse.formData) {
                if (
                    !refwarehouse.formData["orgWarehouseCode"] ||
                    !refwarehouse.formData["shippingMethodCode"]
                ) {
                    flag = true;
                }
            }

            if (flag) {
                this.$Message.error(
                    this.$t("global.common.warning_empty", {
                        defaultValue: "带*的数值不能为空",
                    })
                );
            } else {
                this.loading = true;
                HttpSaveOne({
                    baseInfo: refbase.combaseInfo,
                    receive: refrevice.formData,
                    products: refproduct.comProduct,
                    logistics: refwarehouse.formData,
                })
                    .then(
                        (res) => {
                            this.$Message.success({
                                content: res.message,
                                duration: 10,
                                closable: true,
                            });

                            if (this.querytype == "edit") {
                                this.$emit("on-update");
                                this.$emit("on-close");
                            } else {
                                this.type = "query";
                                this.$router.push({
                                    // name: "b2cOrder"
                                    name: "b2cOrderupdate",
                                    params: { type: "query" },
                                    query: { id: this.id },
                                });
                            }
                        },
                        (err) => {
                            this.$Message.error({
                                content: err.message,
                                duration: 10,
                                closable: true,
                            });
                        }
                    )
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        cancel() {
            if (this.querytype == "edit") {
                this.$emit("on-close");
            } else {
                this.$router.push({
                    name: "b2cOrder",
                });
            }
        },
        filterCode(val) {
            let errorcode;
            switch (val) {
                case "unexception":
                    errorcode = this.$t("erp.b2c.errorcode_unexception", {
                        defaultValue: "无异常的订单",
                    });
                    break;
                case "systemException":
                    errorcode = this.$t("erp.b2c.errorcode_systemException", {
                        defaultValue: "系统异常",
                    });
                    break;
                case "produceException":
                    errorcode = this.$t("erp.b2c.errorcode_produceException", {
                        defaultValue: "商品无法关联",
                    });
                    break;
                case "addressException":
                    errorcode = this.$t("erp.b2c.errorcode_addressException", {
                        defaultValue: "订单地址异常",
                    });
                    break;
                case "updateException":
                    errorcode = this.$t("erp.b2c.errorcode_updateException", {
                        defaultValue: "订单更新异常",
                    });
                    break;
                case "pickingException":
                    errorcode = this.$t("erp.b2c.errorcode_pickingException", {
                        defaultValue: "订单配货异常",
                    });
                    break;
                case "cancelException":
                    errorcode = this.$t("erp.b2c.errorcode_cancelException", {
                        defaultValue: "订单取消异常",
                    });
                    break;
                case "trackingException":
                    errorcode = this.$t("erp.b2c.errorcode_trackingException", {
                        defaultValue: "Tracking异常",
                    });
                    break;
                case "costException":
                    errorcode = this.$t("erp.b2c.errorcode_costException", {
                        defaultValue: "订单成本异常",
                    });
                    break;
                case "carrierException":
                    errorcode = this.$t("erp.b2c.errorcode_carrierException", {
                        defaultValue: "订单发运方式异常",
                    });
                    break;
                case "uploadException":
                    errorcode = this.$t("erp.b2c.errorcode_uploadException", {
                        defaultValue: "订单附件上传异常",
                    });
                    break;
                case "purchaseException":
                    errorcode = this.$t("erp.b2c.errorcode_buylabelException", {
                        defaultValue: "购买面单异常",
                    });
                    break;
            }
            return errorcode;
        },
    },
    beforeDestroy() {},
};
</script>
